import { useCallback, useEffect, useState } from 'react';

const DEV_MODE_STORAGE_KEY = 'dev_mode_unlocked';
const REQUIRED_TAPS = 5;
const TAP_TIMEOUT = 2000; // Reset counter after 2 seconds of no taps

export const useDevMode = () => {
    const [isUnlocked, setIsUnlocked] = useState<boolean>(() => {
        // Check sessionStorage on mount (chỉ tồn tại trong session hiện tại)
        return sessionStorage.getItem(DEV_MODE_STORAGE_KEY) === 'true';
    });

    const [tapCount, setTapCount] = useState(0);
    const [lastTapTime, setLastTapTime] = useState<number>(0);

    useEffect(() => {
        // Reset tap count if too much time has passed
        if (tapCount > 0 && Date.now() - lastTapTime > TAP_TIMEOUT) {
            setTapCount(0);
        }
    }, [tapCount, lastTapTime]);

    const handleLogoClick = useCallback(() => {
        const now = Date.now();

        // Reset if too much time has passed
        if (now - lastTapTime > TAP_TIMEOUT) {
            setTapCount(1);
        } else {
            const newCount = tapCount + 1;
            setTapCount(newCount);

            if (newCount >= REQUIRED_TAPS) {
                setIsUnlocked(true);
                // Dùng sessionStorage thay vì localStorage - sẽ mất khi đóng tab
                sessionStorage.setItem(DEV_MODE_STORAGE_KEY, 'true');
                setTapCount(0); // Reset counter
            }
        }

        setLastTapTime(now);
    }, [tapCount, lastTapTime]);

    return {
        isUnlocked,
        handleLogoClick,
    };
};

